import omit from 'lodash-es/omit';
import pick from 'lodash-es/pick';
import React, { useCallback, useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useDataFieldsSelector, useHistoryStackSelector, useResetToSelector } from '../FormsStateMachine/stateSelectors';
import { CarleadCreationForm } from './CarleadCreationForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CarleadCreationFormStep1(_ref) {
  let {
    children,
    carleadForm,
    machineService
  } = _ref;
  // @ts-expect-error TODO figure out the type of this
  const submitHandler = useCallback(payload => {
    return Promise.resolve(payload);
  }, []);
  return /*#__PURE__*/_jsxs(CarleadCreationForm, {
    carleadForm: carleadForm,
    submitHandler: submitHandler,
    machineService: machineService,
    children: [/*#__PURE__*/_jsx(ClearDataFields, {}), children]
  });
}
export function useClearDataFields() {
  const {
    getState,
    reset
  } = useForm();
  const resetTo = useResetToSelector();
  const stack = useHistoryStackSelector();
  const dataFields = useDataFieldsSelector();
  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (resetTo != undefined && resetTo !== '') {
      const formValues = getState().values;
      const dataValues = pick(formValues, dataFields);
      const otherValues = omit(formValues, dataFields);
      const newValues = pick(dataValues, stack.concat([resetTo]));
      const valuesToUpdate = {
        ...newValues,
        ...otherValues
      };
      reset(valuesToUpdate);
    }
  }, [stack, getState, resetTo, dataFields, reset]);
}
export function ClearDataFields() {
  useClearDataFields();
  return null;
}